<template>
  <div class="page-content iamPromoter" :style="'height: auto;background-color: #F3F5F7;padding: 0;box-shadow: none;'+defaultHeight">
    <div class="bgwhite pad20">
      <div class="startTitle">我是推广主</div>
      <el-row v-if="isdaoshi">
        <el-col :span="24" class="info_box">
          <img :src="daoshiData.userImage" class="iamPromoter_tx">
          <div class="iamPromoter_info">
            <div class="info_type">我的导师</div>
            <div class="info_user"><span class="info_name" v-html="daoshiData.userName"></span><span class="info_wx">{{daoshiData.contentName}}{{daoshiData.content}}</span></div>
          </div>
          <div class="dmh-tgbtn" @click="toPage()">立即推广</div>
        </el-col>
      </el-row>
    </div>
    <div class="">
      <el-row type="flex">
        <el-col :span="12" class="echarts_box bgwhite pad20 mt20" style="margin-right: 2%;;width: 49%">
          <span class="title">我的粉丝</span>
          <el-row class="echarts_textBox">
            <el-col :span="12">
              <span class="title">今日新增</span>
              <span class="numText">{{fansDayCount}}</span>
            </el-col>
            <el-col :span="12">
              <span class="title">全部会员</span>
              <span class="numText">{{fansSumCount}}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div id="line1" style="width: 100%;height:290px;">

              </div>
              <div class="echarts_btn" @click="tofsHistroyChange()">粉丝历史变化</div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="12" class="echarts_box bgwhite pad20 mt20" style="width: 49%">
          <span class="title">预估收益</span>
          <el-row class="echarts_textBox">
            <el-col :span="12">
              <span class="title">今日返利收益</span>
              <span class="numText">{{incomeDayCount}}</span>
            </el-col>
            <el-col :span="12">
              <span class="title">昨日返利收益</span>
              <span class="numText">{{incomeYesterdayCount}}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div id="line2" style="width: 100%;height: 290px;">

              </div>
              <div class="echarts_btn" @click="toshouyichange()">收益变化</div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <!-- 弹出框 推广主 -->
    <el-dialog :visible.sync="open1" width="1000px" :show-close="false" style="line-height:1px; text-align:center; margin-top:0; padding-top:0;">

            <img class='codewrapImg' src='@/assets/images/app_coder2.png'/>
            <div class='codewrapdiv' >即刻加入吾征AI,成为推广主，0投资、增收益，分享赚钱！</div>
            <div class='codewrapdiv' >请您使用吾征AI健康APP或微信公众号即刻获利</div>
            <div class='codewrapdiv2'>（扫描下方二维码下载安装APP或关注吾征AI微信公众号）</div>
            <div style='padding-bottom: 40px;'>
                <div class="codewrap2" >
                  <img src="@/assets/images/app_coder.png">
                  <p>吾征AI健康APP</p>
                  <p>扫码下载</p>
                </div>
                <div class="codewrap2">
                  <img src="@/assets/images/weixin_coder.png">
                  <p>吾征AI公众号</p>
                  <p>扫码关注</p>
                </div>
            </div>
        <!-- 关注公众号 -->
        <div id="alertwarp">
          <div id="alertmask"></div>
          <div id="alertwx">
          </div>
        </div>
      </el-dialog>
  </div>
</template>
<!--{-->
<!--path: '/personCenter/iamPromoter/fsHistroyChange',-->
<!--component:fsHistroyChange-->
<!--},-->
<!--{-->
<!--path: '/personCenter/iamPromoter/shouyichange',-->
<!--component:shouyichange-->
<!--},-->
<script>
import '@/assets/css/backcommon.css'
import { exclusiveTutor, fansRevenueHistory } from '@/api/memberCenter'
import echarts from 'echarts'
const animationDuration = 6000
export default {
  name: "iamPromoter",
  data () {
    return {
      open1: false,
      isdaoshi: "",
      defaultHeight: {
        height: ""
      },
      chart_line1: null,
      chart_line2: null,
      line1_data: [],
      line2_data: [],
      fansLine: '',
      incomeLine: "",
      fansDayCount: '',
      fansSumCount: '',
      incomeDayCount: '',
      incomeSumCount: "",
      incomeYesterdayCount: "",
      daoshiData: ""
    }
  },
  methods: {
    //弹出推广主
    toPage(){
      this.open1 = true;
    },
    //定义方法，获取高度减去头尾
    getHeight () {
      this.defaultHeight.height = window.innerHeight - 146 + "px";
    },
    tofsHistroyChange () {
      this.$router.push("/personCenter/iamPromoter/fsHistroyChange");
    },
    toshouyichange () {
      this.$router.push("/personCenter/iamPromoter/shouyichange");
    },
    //专属导师
    exclusiveTutor () {
      exclusiveTutor({}).then(res => {
        console.log(res);
        if (res.data.code == 500) {
          this.isdaoshi = false;
          this.daoshiData = '';
          this.message(res.data.msg);
        }
        if (res.data.code == 200) {
          this.isdaoshi = true;
          this.daoshiData = res.data.data;
        }
      });
    },
    //粉丝、收益历史
    fansRevenueHistory () {
      fansRevenueHistory({}).then(res => {
        console.log(res);
        if (parseFloat(res.data.code) === 200) {
          var data = res.data;
          this.fansLine = data.fansLine;
          this.incomeLine = data.incomeLine;
          this.fansDayCount = data.fansDayCount;
          this.fansSumCount = data.fansSumCount;
          this.incomeDayCount = data.incomeDayCount;
          this.incomeSumCount = data.incomeSumCount;
          this.incomeYesterdayCount = data.incomeYesterdayCount;
          this.$nextTick(() => {
            this.initChart_line1(this.fansLine.name, this.fansLine.time, this.fansLine.series);
            this.initChart_line2(this.incomeLine.name, this.incomeLine.time, this.incomeLine.series);
          })
        }
      });
    },
    initChart_line1 (legend, data, series) {
      this.chart_qx = echarts.init(document.getElementById("line1"), 'macarons');
      this.chart_qx.setOption({
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          /* data: legend,
           // icon: "circle",
           bottom: "-3%",
           itemGap:10*/
          data: legend,
          icon: "circle",
          top: "0%",
          right: "3%",
          itemGap: 10
        },
        dataZoom: [{
          /*type: 'slider',
          show: true,
          xAxisIndex: [0],
          left: '9%',
          bottom: -5,
          start: 10,
          end: 90 //初始化滚动条*/

          start: 0,//默认为0
          end: 30,//默认为100
          type: 'slider',
          show: true,
          xAxisIndex: [0],
          handleSize: 0,//滑动条的 左右2个滑动条的大小
          height: 10,//组件高度
          left: '5%', //左边的距离
          right: '1%',//右边的距离
          bottom: 26,//右边的距离
          borderColor: "#F0ECF8",
          fillerColor: '#14C86CFF',
          borderRadius: 5,
          backgroundColor: "#F0ECF8",//两边未选中的滑动条区域的颜色
          showDataShadow: false,//是否显示数据阴影 默认auto
          showDetail: false,//即拖拽时候是否显示详细数值信息 默认true
          realtime: true, //是否实时更新
          filterMode: 'filter',


        }],
        grid: {
          top: "13%",
          left: '1%',
          right: '3',
          bottom: '13%',
          containLabel: true
        },
        color: ['#F0B652', '#58ABED'],
        xAxis: {
          axisLabel: {
            show: true,
            textStyle: {
              color: '#656565',
              fontSize: "10",
              padding: [3, 0, 0, 0]
            }
          },
          offset: [1],
          axisTick: { show: false },
          axisLine: { show: false },

          type: 'category',
          boundaryGap: false,

          data: data
        },
        yAxis: {
          axisLabel: {
            show: true,
            textStyle: {
              color: '#1B2D32',
              fontSize: "13",
              padding: [0, 10, 0, 0]
            }
          },

          axisTick: { show: false },
          axisLine: { show: false },
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#E5E5E5'],
              width: 1,
              type: 'solid'
            }
          },
          splitArea: { show: false }//保留网格区域
        },
        series: series
      })
    },
    initChart_line2 (legend, data, series) {
      this.chart_qx = echarts.init(document.getElementById("line2"), 'macarons');
      this.chart_qx.setOption({


        legend: {
          data: legend,
          icon: "circle",
          top: "0%",
          right: "3%",
          itemGap: 10
        },
        grid: {
          top: "13%",
          left: '1%',
          right: '3%',
          bottom: '13%',
          containLabel: true
        },
        dataZoom: [{
          start: 0,//默认为0
          end: 30,//默认为100
          type: 'slider',
          show: true,
          xAxisIndex: [0],
          handleSize: 0,//滑动条的 左右2个滑动条的大小
          height: 10,//组件高度
          left: '5%', //左边的距离
          right: '1%',//右边的距离
          bottom: 26,//右边的距离
          borderColor: "#F0ECF8",
          fillerColor: '#14C86CFF',
          borderRadius: 5,
          backgroundColor: "#F0ECF8",//两边未选中的滑动条区域的颜色
          showDataShadow: false,//是否显示数据阴影 默认auto
          showDetail: false,//即拖拽时候是否显示详细数值信息 默认true
          realtime: true, //是否实时更新
          filterMode: 'filter',
        }],
        color: ['#F0B652', '#58ABED', '#94D66C'],
        xAxis: {
          axisLabel: {
            show: true,
            textStyle: {
              color: '#656565',
              fontSize: "10",
              padding: [3, 0, 0, 0]
            }
          },
          // offset:[4],
          axisTick: { show: false },
          axisLine: { show: false },
          type: 'category',
          boundaryGap: false,
          data: data
        },
        yAxis: {
          axisLabel: {
            show: true,
            textStyle: {
              color: '#1B2D32',
              fontSize: "13",
              padding: [0, 10, 0, 0]
            }
          },

          axisTick: { show: false },
          axisLine: { show: false },
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#E5E5E5'],
              width: 1,
              type: 'solid'
            }
          },
          splitArea: { show: false }//保留网格区域
        },
        series: series
      })
    }
  },
  beforeDestroy () {
    if (!this.chart_line1) {
      return
    }
    this.chart_line1.dispose();
    this.chart_line1 = null;
    if (!this.chart_line2) {
      return
    }
    this.chart_line2.dispose();
    this.chart_line2 = null;
  },
  mounted () {
    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    this.exclusiveTutor();
    this.fansRevenueHistory();

  }
}
</script>

<style scoped>
.bgwhite {
  background-color: #ffffff;
}
.mt20 {
  margin-top: 20px;
}
.pad20 {
  padding: 20px;
  padding-bottom: 15px;
}
.iamPromoter .info_box {
  padding-top: 20px;
  position: relative;
  /*padding-bottom: 20px;*/
}
.iamPromoter .iamPromoter_tx {
  width: 90px;
  height: 90px;
  display: inline-block;
}
.iamPromoter .iamPromoter_info {
  display: inline-block;
  margin-left: 20px;
  margin-top: 8px;
  position: relative;
}
.iamPromoter .iamPromoter_info .info_type {
  font-size: 16px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  margin-bottom: 12px;
}

.iamPromoter .iamPromoter_info .info_user .info_name {
  font-size: 24px;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  margin-right: 40px;
}
.iamPromoter .iamPromoter_info .info_user .info_wx {
  font-size: 16px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.dmh-tgbtn {
  position: absolute;
  right: 0;
  top: 35px;
  width: 120px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  background: #ff5454;
  color: #fff;
  font-size: 15px;
  border-radius: 5px;
  cursor: pointer;
}
.dmh-tgbtn:hover {
  opacity: 0.9;
}
.echarts_box {
  padding-top: 15px;
  padding-bottom: 15px;
}
.echarts_box .title {
  text-align: center;
  display: block;
  font-size: 16px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.echarts_textBox {
  padding-top: 20px;
  padding-bottom: 10px;
}
.echarts_textBox .title {
  text-align: center;
  display: block;
  font-size: 15px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.echarts_textBox .numText {
  padding-top: 10px;
  text-align: center;
  display: block;
  font-size: 23px;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
}
.echarts_btn {
  background-color: #14c86cff;
  width: 150px;
  line-height: 40px;
  font-size: 15px;
  color: #ffffff;
  text-align: center;
  border-radius: 5px;
  margin: 0px auto 10px;
  cursor: pointer;
}
.daoshiText {
  line-height: 60px;
  padding-left: 20px;
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/views/personCenter/iamPromoter.vue